import { FilterOnEmptyState, LoadingSpinner, NoFlyersAvailableEmptyState } from '@/components';
import { FlyerList } from '@/components/FlyerboardPagination/FlyerList';
import { useJarFlyerboardContext } from '@/context/JarFlyerboardContext';
import { useFlyerboardPagination, useURLSearchParams } from '@/hooks';
import { css } from '@emotion/css';

export const JarFlyerboardList = () => {
  const { audienceId } = useURLSearchParams();
  const { filters, resetQuickFilters, amountActiveFilters, districtId } = useJarFlyerboardContext();
  const { flyers, loading, fetchMoreFlyers, total, dataNotFound } = useFlyerboardPagination({
    audienceId,
    districtId,
    flyerboardFilters: filters || { schoolIds: [] },
    skip: !filters,
  });

  const resetFilters = () => {
    resetQuickFilters();
  };

  const EmptyState = () => {
    if (dataNotFound) {
      if (amountActiveFilters > 0) {
        return <FilterOnEmptyState onClick={resetFilters} />;
      }
      return <NoFlyersAvailableEmptyState />;
    }
    return null;
  };

  return (
    <main className={cn.container}>
      {loading && flyers.length === 0 && <LoadingSpinner />}
      <EmptyState />
      {flyers.length > 0 && (
        <>
          <FlyerList
            flyers={flyers}
            nextPage={fetchMoreFlyers}
            total={total}
            trackId="jar"
            audienceId={audienceId}
            districtId={districtId}
            trackingEventFrom="jar"
            showTags
          />
        </>
      )}
    </main>
  );
};

const cn = {
  container: css`
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    flex-grow: 10;
  `,
};
